import $ from "jquery";

export function installAds(insElements: JQuery) {
  // console.log(`we have ${insElements.length} ads blocks`);
  // window.adsbygoogle = window.adsbygoogle || [];
  // const filtered = insElements.filter(function() {
  //   console.log(`width=${$(this).css("width")} display=${$(this).css("display")}`);
  //   return $(this).css("display") !== "none"
  //       && $(this).parentsUntil(".section").filter(function() {
  //         const display = $(this).css("display");
  //         console.dir(this);
  //         console.log("display="+display)
  //         return display === "none";
  //       }).length === 0;
  // });
  // console.log(`we have ${filtered.length} filtered elements`);
  // filtered.each((idx, element) => {
  //   try {
  //     window.adsbygoogle.push({});
  //   } catch (e) {
  //     console.error(e);
  //     console.error(`idx=${idx}`);
  //     console.dir(element);
  //   }
  // });
  let countDown = 20;
  const intervalId = window.setInterval(() => {
    const parents = $(".adsbygoogle").parentsUntil("#app", "[style]").filter(function() {
      const style = $(this).attr("style");
      console.log("style=" + style);
      return style ? style.indexOf("auto") >= 0 : false;
    });
    console.log(`We have ${parents.length} parents with heigt=auto attr`);
    if (parents.length > 0) {
      parents.removeAttr("style");
    } else {
      if (--countDown === 0) {
        window.clearInterval(intervalId);
      }
    }
  }, 200);
}
